import { CheckEnvironment, SupportedEnvironments } from './environment';
import { QA_DOMAIN, QA_DOMAIN_SUFFIX } from '../config';

/**
 * Determines if the current client environment is in a "custom domain mode"
 * for development purposes. This mode enables special authentication flows
 * like custom Firebase tokens.
 *
 * Custom domain mode is active ONLY in development builds for:
 * - `localhost`
 * - Feature branches (e.g., `feat-*.owner-portal-v2.pages.dev`)
 *
 * It is NOT active for:
 * - Production builds
 * - The main QA domain (`qa.owner-portal-v2.pages.dev`)
 * - Any other custom domain not explicitly supported (falls through to standard flow)
 *
 * @returns {boolean} True if in custom domain mode, false otherwise.
 */
export const isCustomDomainMode = (): boolean => {
  if (!CheckEnvironment(SupportedEnvironments.Dev)) {
    return false; // Never in production
  }

  const { hostname } = window.location;

  // Only use standard flow for the main QA domain, not feature branches
  if (hostname === QA_DOMAIN) {
    return false;
  }

  // Feature branches like feat-*.owner-portal-v2.pages.dev should use custom tokens
  if (hostname.endsWith(QA_DOMAIN_SUFFIX)) {
    return true;
  }

  // Only support localhost for custom domains
  if (hostname === 'localhost' || hostname.startsWith('localhost:')) {
    return true;
  }

  // For any other custom domain, use standard flow
  return false;
};
